import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { ToastContainer } from "react-toastify";
import { Base64, btoa, encode } from 'js-base64';


import defaultValues from '../../constant/defaultValues';

import { useAuth } from '../../AuthProvider';
import { buildPath, getRandomInteger } from '../../utils/common';

import { hideLoading, showLoading } from '../../actions/loaderAction';

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from '../../components/InputField';
import SubHeader from '../../components/SubHeader';
import BuyerSupplierFilter from '../../components/memberFilter/buyerSupplierFilter';

import Emitter from '../../utils/Emitter';
import { debounce, find, isEmpty, size } from 'lodash';
import { FilterBuyersSupplier } from '../../actions/shipmentAction';
import MediumPopup from '../../components/MediumPopup';
import ToolipsCustom from '../../components/ToolipsCustom';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';



function BuyerSupplier(props) {

    const { admin, COMPANY_DEFAULTS } = defaultValues;
    const statusList = COMPANY_DEFAULTS.STATUS;
    const { user, isEndUser, isSuperAdmin, isPreKYCUser, isDemoUser, isViewer, isOperationUser } = useAuth();

    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [current_page, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);

    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState("Company Name");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);

    const [mediummodalShow, setMediumModalShow] = useState(false);
    const [tableKey, setTableKey] = useState(0);
    const [nodata, setNoData] = useState(false);


    const [searchFilterObj, setFilterObj] = useState({
        filterBy: "hs_code",
        offset: admin.OFFSET,
        limit: admin.LIMIT,
        columnName: "Company Name",
        sortDirection: admin.SORT_DIRECTION,
        filter_val: "",
        selected_companies: [],
        selected_hscodes: [],
        selected_services: [],
        selected_target_country: [],
        selected_country: [],
        table_search: "",
        findWhom: "Supplier",
        current_page: 1
    })

    const columns = [
        {
            name: 'Sr No',
            selector: (row, idx) => {
                return (
                    <>{offset + (idx + 1)}</>
                )
            },
            resizable: true,
            // width: "100px"
            width: "5%"
        },
        {
            name: 'Orex ID',
            selector: row => <div className='text-wrap'>{'OTD' + getRandomInteger(100001, 999999)}</div>,
            resizable: true,
            // width: "150px"
            width: "13%",
            // columnName: "id",
            sortable: false
        },
        {
            name: 'Company Name', // to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id })}`}
            selector: row => <div className={`text-wrap  ${(row.data_source_type === 1 ? 'text-decoration-underline' : '')}`}>
                {(row.data_source_type === 1) ? (
                    <Link style={{ color: "#0c4572" }} to={`/${getPrefix()}${buildPath(privateRoutePaths.SHIPMENT_TRADE_DETAIL, {
                        type: searchFilterObj.findWhom.charAt(0).toLowerCase(),
                        company_name: btoa(new TextEncoder()
                            .encode(row.company_name)
                            .reduce((data, byte) => data + String.fromCharCode(byte), ''))
                    })}`} target="_blank">
                        {row.company_name}
                    </Link>
                ) : (
                    row.company_name
                )}
            </div>,
            //  width:"250px"
            width: "35%",
            // columnName: "company_name",
            sortable: true
        },
        // {
        //     name: 'HS Code',
        //     selector: row => <div className="tbl-text-wrap-row"> {(row.hs_code ? row.hs_code : '')}</div>,
        //     resizable: true,
        // width: "200px"
        //   width: "10%",
        // columnName: "first_name",
        //     sortable: true
        // },
        // {
        //     name: 'Product',
        //     selector: row => <div className='tbl-text-wrap-row'>{row.product_desc}</div>,
        //     resizable: true,
        // width: "250px"
        //    width: "20%",
        // columnName: "email",
        //   sortable: true
        // },
        {
            name: 'Trade Mode',
            selector: row => <div className='text-wrap'>{row.trade_mode}</div>,
            resizable: true,
            //width: "150px"
            width: "13%",
            // columnName: "shipment_mode",
            sortable: true
        },
        {
            name: 'Country',
            selector: row => <div className='text-wrap'>{row.country}</div>,
            resizable: true,
            // width: "150px"
            width: "19%",
            // columnName: "country_name",
            sortable: true
        },
        // {
        //     name: 'Status',
        //     selector: row => <div className='text-wrap'>{"Active"}</div>,
        //     resizable: true,
        // width: "150px"
        //   width: "9%",
        // columnName: "country_name",
        //     sortable: false
        // },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="text-wrap">
                    <ToolipsCustom
                        subtitle="View"
                        className="fa-regular fa-eye icon-eyes border-0 "
                        classNameChild={"data-table-tooltiop"}
                        onClick={(e) => handleViewClick(e)}
                    >

                    </ToolipsCustom>

                    {/* <button className="btn action-icon-btn m-0 p-0 mx-2 " data-toggle="tooltip" data-placement="top" title="View" onClick={(e) => handleViewClick(e)}>
                        <i className="fa-regular fa-eye icon-eyes"></i>
                    </button> */}
                </div>
            ),
            // resizable: true,
            // width: "100px"
            width: "10%"
        }

    ];

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        if (user && isOperationUser) return roles.OPERATION_USER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    const handleViewClick = (e) => {
        setMediumModalShow(true);
    }

    const handleSort = async (column, sortDirection) => {
        if (column.name != undefined && column.name != "" && column.name != null) {
            setColumnName(column.name);
            setSortDirection(sortDirection);
            // filterMemberData(
            //     admin.OFFSET,
            //     admin.LIMIT,
            //     current_page,
            //     column.name,
            //     sortDirection,
            //     searchTxt
            // );
            filterMemberData(
                offset,
                limit,
                current_page,
                column.name,
                sortDirection,
                searchTxt
            );
        }
    };

    const onSearchTextBoxChanged = debounce((e) => {
        // console.log("Search Val === ", e.target.value);
        // setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        //props.showLoading();
        if ((searchVal.length >= 3 || searchVal.length == 0) && (searchVal != searchTxt)) {
            let sFilter = { ...searchFilterObj };
            sFilter.table_search = searchVal;
            setFilterObj(sFilter);
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName("Company Name");
            setSortDirection(admin.SORT_DIRECTION);
            setSearchTxt(e.target.value);
            setCurrentPage(1);
            setTableKey((prev) => prev + 1);
            setTimeout(async () => {

                await filterMemberData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchVal);


            }, 1500);

        }
    });


    const filterMemberData = async (ofst = 0, lmt = 10, cur_page = 1, columnName = "custom_order", sortDirection = "DESC", searchval = "",) => {

        // console.log("filterMemberData  function args === ", ofst, lmt);
        setNoData(false);
        await props.showLoading();
        let fObj = { ...searchFilterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            fObj.offset = ofst;
            fObj.limit = lmt;
            fObj.columnName = columnName;
            fObj.sortDirection = sortDirection;
            fObj.table_search = searchval;
            fObj.current_page = cur_page;

            await props.FilterBuyersSupplier(fObj).then((response) => {
                if (response) {
                    if (response.status === true) {

                        if (size(response.data) === 0) {
                            setNoData(true);
                        }

                        setMemberList(response.data);
                        settotalRows(response.metadata.total);
                    }
                }
            }).catch((err) => {
                console.log("Error ==== ", err);
            });

        }
        await props.hideLoading();
    }

    const setMembersFilters = (newState) => {
        // console.log("newState =================== ", newState);

        newState.table_search = "";
        newState.current_page = 1;
        setSearchTxt(null);
        setCurrentPage(1);
        document.getElementById("filter-text-box").value = null;
        setLimit(newState.limit);
        setOffset(newState.offset);
        setFilterObj(newState);
        setTableKey((prev) => prev + 1);
    }

    const filterApplyOnMembers = (filterObj) => {

        filterMemberData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchTxt);


    }

    useEffect(() => {
        async function fetchData() {
            // You can await here
            // getRegisteredMembers(offset, limit, searchTxt);
            initialRef.current = false;

            await filterMemberData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchTxt);


        }
        if (initialRef.current === true) {
            //fetchData();
        }

    }, []);

    useEffect(() => {
        // Emitter.on("FILTER_MEMBERS", filterMemberData);
        Emitter.on("FILTER_MEMBERS", filterApplyOnMembers);
        Emitter.on("SET_FILTER_MEMBERS", setMembersFilters);
        return () => {
            Emitter.off("FILTER_MEMBERS", filterApplyOnMembers);
        };
    });


    const expandedRowComponent = ({ data }) => {
        const statusLabel = 'Active';
        return (

            <div style={{ padding: '20px', borderTop: '1px solid #ddd' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: '22px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px'
                }}>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>HS Code:</strong> {(data.hs_code ? data.hs_code : '-')}
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Product:</strong> {(data.product_desc ? data.product_desc : '-')}
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Product Tags:</strong> {(data.product_tags ? data.product_tags : '-')}
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Status:</strong> {statusLabel}
                        </div>

                    </div>

                </div>
            </div>
        );
    };

    return (<>
        <div className='data-table-main'>

            <div className="AcSimpleTable">
                <SubHeader
                    layer1="Supplier Directory"
                    layer2=""
                    layer3="List"
                    pageName="Suppliers"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />

                <div className='filter-section'>
                    <BuyerSupplierFilter />
                </div>

                <div className='card1'>

                    <div className='table-header-name'>
                        <h5 className='table-text'>List</h5>
                        <div className='d-flex justify-content-between align-items-center p-3'>
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25'
                                onKeyUp={onSearchTextBoxChanged}
                                // onChange={onSearchTextBoxChanged}
                                // value={searchTxt}
                                autoComplete="off"
                            ></InputField>
                        </div>

                    </div>

                    <div className="table-wrapper">
                        <div className="table-container" style={{ overflowX: 'auto', width: "100%" }}>
                            {memberList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={memberList}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={filterMemberData}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    // setColumnName={setColumnName}
                                    // setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    searchTxt={searchTxt}
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    current_page={current_page}
                                    setCurrentPage={setCurrentPage}
                                    expandableRows
                                    expandableRowsComponent={expandedRowComponent}
                                    noData={nodata}
                                />
                            )}
                        </div>
                    </div>

                </div>

            </div>

            <MediumPopup
                title={"Access Denied!"}
                mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow}
            >
                <div className='text-center'>
                    <p><b>
                        You do not have access to view more details.

                    </b></p></div>
                <div className='text-center'>
                    <p>If you wish to view additional details of the buyer or supplier, please contact an Admin or email  <a href={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`}>{process.env.REACT_APP_SUPPORT_MAIL}.</a>
                    </p>
                </div>

            </MediumPopup >
            {/* <ToastContainer /> */}
        </div >

    </>)
}

const mapStateToProps = state => {

    return {
        // member_list: state.member.memberlist,
        // authError: state.auth.errorMessages
    }
}
const mapDispatchToProps = dispatch => {
    return {
        // getMembers: (offset, limit, searchTxt) => dispatch(getMemberList(offset, limit, searchTxt)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        FilterBuyersSupplier: (filterData) => dispatch(FilterBuyersSupplier(filterData)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerSupplier);
